export default __webpack_public_path__ + "5a60b4c42ff61ad17d8b42b1242a7cd3.png";